import { jsx as _jsx } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2023 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { InfoIcon } from "./Icons";
import HoverOverlay from "./HoverOverlay";
import Markdown from "./Markdown";
function InfoTooltip(props) {
    const { contents, disableMarkdown } = props;
    let renderedContents = contents;
    if (typeof contents === "string") {
        renderedContents =
            disableMarkdown === true ? (contents) : (_jsx(Markdown, { contents: contents }));
    }
    return (_jsx("span", { onClick: (e) => e.stopPropagation(), children: _jsx(HoverOverlay, { contents: renderedContents, children: _jsx("div", { className: "tooltip-wrapper", children: _jsx(InfoIcon, {}) }) }) }));
}
export default InfoTooltip;
